<script>
export let snow;
</script>

<div>
    <span title="Snow accumulation">&#x2603; {snow} kg/m<sup>2</sup></span>
</div>
